import styled from "styled-components"

import BaseButton from "@irati/ui/src/Button"

export const Wrapper = styled.div`
  border: 1px solid ${({theme}) => theme.colors.primary2_100};
  box-sizing: border-box;
  border-radius: 8px;
`

export const Button = styled(BaseButton)`
  border-radius: 8px;
  ${({primary, theme}) =>
    !primary &&
    `
    border: transparent;
    &:hover, &:focus, &:active {
      color: ${theme.colors.primary2};
      background-color: transparent;
      box-shadow: 0px ${theme.colors.primary2};
    }
  `}
`
